import { Tab } from "react-bootstrap";
import { Container , Row , Col , Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectsCard";
import projImg1 from "../assets/img/project-img1.png"
import projImg2 from "../assets/img/project-img2.png"
import projImg3 from "../assets/img/mrsys.png"
import cert1 from "../assets/img/google.jpeg";
import cert2 from "../assets/img/microsoft.jpeg";
import cert3 from "../assets/img/CN_ML_Abhishek.jpg";
import cert4 from "../assets/img/kaggle.png";
import cert5 from "../assets/img/problemsolving.jpeg";
import cert6 from "../assets/img/python.jpeg";
import cert7 from "../assets/img/paperpresent.png";

export const Projects = () =>{

    const  projects1 = [
        {
            title :"Website for Department of Environmental Engineering DTU",
            description : "Design & Development",
            imgUrl : projImg1,
        },
        {
            title :"Personal Portfolio",
            description : "Design & Development",
            imgUrl : projImg2,
        },
        {
            title :"Movie Recommendation System",
            description : "ML Project : Used Streamlit for webdesign",
            imgUrl : projImg3,
        },
        // {
        //     title :"Business StartUp",
        //     description : "Design & Development",
        //     imgUrl : projImg3,
        // },
    ];
     const  projects2 = [
        {
            title :"Certificate of Paper Presentation",
            description : "Investigating the Impact of Temperature on Skin Cancer Death Rates: A Geographic Information System (GIS) Approach",
            imgUrl : cert7,
        },
        {
            title :"Machine Learning using Python and SKlearn",
            description : "Design & Development",
            imgUrl : cert1,
        },
        {
            title :"Machine Learning using Python and SKlearn",
            description : "Design & Development",
            imgUrl : cert2,
        },
        {
            title :"Basics Of Machine Learning",
            description : "Design & Development",
            imgUrl : cert3,
        },
        {
            title :"Intro to Machine Learning",
            description : "Design & Development",
            imgUrl : cert4,
        },
        {
            title :"Problem Solving",
            description : "Problem Solving Certifite test on HackerRank",
            imgUrl : cert5,
        },
        {
            title :"Python",
            description : "Python Certifite test on HackerRank",
            imgUrl : cert6,
        },
    ];
    // const  projects3 = [
    //     {
    //         title :"Business StartUp",
    //         description : "Design & Development",
    //         imgUrl : projImg1,
    //     },
    //     {
    //         title :"Business StartUp",
    //         description : "Design & Development",
    //         imgUrl : projImg2,
    //     },
    //     {
    //         title :"Business StartUp",
    //         description : "Design & Development",
    //         imgUrl : projImg3,
    //     },
    // ];

    return (
        <section className = "project" id="project">
            <Container>
                <Row>
                    <Col>
                    <h2>Projects</h2>
                    <p>tap on certificate to view certificates!</p>
                    <Tab.Container id ="project-tabs" defaultActiveKey="first">
                    <Nav varient = "pills"className="nav-pills mb-5 justify-content-center align-items-center" id= "pills-tab" >
                        <Nav.Item>
                            <Nav.Link eventKey="first">Projects</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey = "second">Certificates</Nav.Link>
                        </Nav.Item>
                        {/* <Nav.Item>
                            <Nav.Link eventKey = "third">Tab Three</Nav.Link>
                        </Nav.Item> */}
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane eventKey="first">
                            <Row>
                                {
                                    projects1.map((project,index)=>{
                                        return (
                                            <ProjectCard 
                                            key = {index}
                                            {...project}
                                            />
                                        )
                                        })
                                }
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey ="second">
                        <Row>
                                {
                                    projects2.map((project,index)=>{
                                        return (
                                            <ProjectCard 
                                            key = {index}
                                            {...project}
                                            />
                                        )
                                        })
                                }
                        </Row>
                        </Tab.Pane>
                        {/* <Tab.Pane eventKey ="third">Lorem Ipsum</Tab.Pane> */}
                    </Tab.Content>
                    </Tab.Container>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}